import { rootApi } from 'root-api-graphql'

const SubmitQueryMutation = `
  mutation SubmitQuery($query: String!, $threadId: UUID) {
    submitQuery(input: {query: $query, threadId: $threadId}) {
      status
      queryId
      threadId
      message
    }
  }
`

const QueryStatusQuery = `
  query QueryStatus($queryId: UUID!) {
    queryStatus(queryId: $queryId) {
      queryId
      responseId
      error
      errorCode
      status
      content
      toolCalls {
        edges {
          node {
            id
            name
            timestamp
          }
        }
      }
    }
  }
`

const ThreadQuery = `
  query Thread($input: ThreadInput!) {
    thread(input: $input) {
      threadId
      messages {
        edges {
          node {
            messageId
            content
            role
            timestamp
          }
        }
      }
    }
  }
`

const getCafApiGraphqlUrl = () => {
  const value = typeof window !== 'undefined' && window.CAF_API_GRAPHQL_BASE
  return (value && String(value)) || '/api/caf-api/graphql'
}

const baseUrl = getCafApiGraphqlUrl()

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    submitQuery: build.mutation({
      query: (variables) => ({ document: SubmitQueryMutation, variables, meta: { baseUrl } }),
      invalidatesTags: (result, error, arg) => [
        { type: 'Thread', id: result?.submitQuery?.threadId }
      ],
    }),
    queryStatus: build.query({
      query: (variables) => ({
        document: QueryStatusQuery,
        variables,
        meta: { baseUrl, treatGraphqlErrorsAsFailure: true },
      }),
    }),
    thread: build.query({
      query: (variables) => ({ document: ThreadQuery, variables, meta: { baseUrl } }),
      providesTags: (result, error, arg) => [
        { type: 'Thread', id: arg.input.threadId }
      ],
    })
  })
})

export const {
  useSubmitQueryMutation,
  useQueryStatusQuery,
  useThreadQuery
} = api
